import axios from 'axios'
import { getEnvVar } from '@/assets/js/helpers'

const CancelToken = axios.CancelToken
let cancelGetChamps
let cancelClubRating
let cancelClubTraining

const apiClient = axios.create({
  baseURL: getEnvVar('VUE_APP_CHAMPS_API_URL') + 'api/championships/clubs',
  withCredentials: true
})

export default {
  getAchievements ({ clubId }) {
    return apiClient.post(`/${clubId}/achievements/ru`)
  },
  getStarts ({ clubId }) {
    return apiClient.post(`${clubId}/championships/info/ru`, {
      TakeNextStarts: 4
    })
  },
  getSeasons ({ clubId, championshipsType }) {
    return apiClient.post(`/${clubId}/championships/seasons`, {
      ChampionshipsType: championshipsType
    })
  },
  getChamps ({ clubId, championshipsType, onlyOneId, seasonYear, userId, searchString, onlyActive, showDrafts, skip, take, orderByStatus }) {
    if (cancelGetChamps) {
      cancelGetChamps('canceled')
    }
    return apiClient.post(`${clubId}/championships/ru`, {
      ChampionshipsType: championshipsType,
      OnlyOneId: onlyOneId,
      SeasonYear: seasonYear,
      CurrentUserId: userId,
      SearchString: searchString,
      OnlyActive: onlyActive,
      OrderByStatus: orderByStatus,
      ShowDrafts: showDrafts,
      Skip: skip,
      Take: take
    }, {
      cancelToken: new CancelToken(function executor (c) {
        cancelGetChamps = c
      })
    })
  },
  deleteChamp ({ champId }) {
    return apiClient.post(`/championships/${champId}/delete`)
  },
  createChamp ({ clubId, clubCode, clubName, code, name, description, startDate, finishDate, discipline }) {
    return apiClient.post('/championships/create', {
      Club: {
        Id: clubId,
        Code: clubCode,
        Name: clubName
      },
      Code: code,
      Name: name,
      Description: description,
      StartDate: startDate,
      FinishDate: finishDate,
      DisciplineCode: discipline
    })
  },
  editChampInfo ({ champId, clubId, clubCode, clubName, code, name, description, startDate, finishDate, discipline }) {
    return apiClient.post(`/championships/${champId}/general/save`, {
      Club: {
        Id: clubId,
        Code: clubCode,
        Name: clubName
      },
      Code: code,
      Name: name,
      Description: description,
      StartDate: startDate,
      FinishDate: finishDate,
      DisciplineCode: discipline
    })
  },
  editChampNominations ({ champId, nominations }) {
    return apiClient.post(`/championships/${champId}/nominations/save`, {
      Nominations: nominations
    })
  },
  editChampStages ({ champId, stages }) {
    return apiClient.post(`/championships/${champId}/stages/save`, {
      DatesStages: stages
    })
  },
  getChampInfo ({ champId }) {
    return apiClient.post(`/championships/${champId}/general/ru`)
  },
  getChampNominations ({ champId }) {
    return apiClient.post(`/championships/${champId}/nominations/ru`)
  },
  getChampStages ({ champId }) {
    return apiClient.post(`/championships/${champId}/stages/ru`)
  },
  publish ({ champId }) {
    return apiClient.post(`/championships/${champId}/publish`)
  },
  getClubTrainingCount (clubCode) {
    return apiClient.post('/championships/get-activities-count', {
      clubCode
    })
  },
  cancelGettingTraining () {
    cancelClubTraining && cancelClubTraining('canceled')
  },
  getClubTraining ({ clubCode, city, disciplineCode, page, pageSize }) {
    const data = {
      clubCode,
      city,
      disciplineCode,
      page,
      pageSize
    }

    return apiClient.post('/championships/get-activities', data, {
      cancelToken: new CancelToken(function executor (c) {
        cancelClubTraining = c
      })
    })
  },
  getClubMembersRating ({ data: { clubCode, disciplineCode, gender, city, week, sortBy, sortOrder, page, pageSize }, cancel }) {
    if (cancel) {
      cancelClubRating && cancelClubRating('canceled')
    }
    return apiClient.post('/championships/get-members', {
      clubCode,
      disciplineCode,
      gender,
      city,
      week,
      sortBy,
      sortOrder,
      page,
      pageSize
    }, {
      cancelToken: new CancelToken(function executor (c) {
        cancelClubRating = c
      })
    })
  },
  getTrainingFilters ({ clubCode, withNoActivities }) {
    const withNoActivitiesParam = withNoActivities ? `&withNoActivities=${withNoActivities}` : ''
    return apiClient.post(`/championships/get-activity-filters?clubCode=${clubCode}${withNoActivitiesParam}`)
  },
  getClubLeaders ({ clubCode }) {
    return apiClient.post('/championships/get-leaders', {
      clubCode
    })
  },
  getClubMap ({ city, searchString, sportTypes }) {
    return apiClient.post('/championships/map/clubs', {
      searchString,
      sportTypes,
      city
    })
  },
  getClubsMembersCount (ids) {
    return apiClient.post('/championships/map/clubs-members-count', {
      Ids: ids
    })
  }
}
